import React from 'react';
import Formsy from 'formsy-react';
import Calendar from 'react-calendar';
import moment from 'moment';
import FormsySimpleInput from '../../form/FormsySimpleInput';
import withOnboarding from '../withOnboarding';
import { maskCapitalizeFirstLetter } from '../../../masks';

class ClientStartDate extends React.Component {
  state = {
    serviceDate: null
  };

  render() {
    // render form
    const { serviceDate } = this.state;
    const { day_of_week, start_time } =
      this.props.client.client_service_preferences[0] || {};
    const time = moment(start_time, ['HH:mm']).format('h:mm A');

    return (
      <div className="on-boarding__step on-boarding_step--client">
        <div className="on-boarding__wrap on-boarding__wrap--client-start-date">
          <h1 className="on-boarding__h1">
            Great, {maskCapitalizeFirstLetter(day_of_week)}s at {time}. What day
            would you like your service to start?
          </h1>
          <p className="on-boarding__p">
            You can skip a week and make other changes later.
          </p>

          <div className="on-boarding__calendar">
            <Calendar
              calendarType="US"
              activeStartDate={new Date()}
              value={serviceDate}
              minDetail="year"
              onChange={this.handleClickDay}
              onClickDay={this.handleClickDay}
              minDate={new Date()}
              formatMonthYear={(_, value) => moment(value).format('MMMM YYYY')}
              // formatShortWeekday={value => moment(value).format('dd')} // no single digit option
              tileDisabled={this.disableTile}
            />
          </div>

          <Formsy
            onValidSubmit={this.handleSubmit}
            onInvalidSubmit={this.handleInvalidSubmit}
            onValid={this.handleValid}
            onInvalid={this.handleInvalid}
          >
            <FormsySimpleInput
              type="hidden"
              name="serviceDate"
              value={serviceDate ? serviceDate.toString() : ''}
              required
            />
            <FormsySimpleInput
              type="hidden"
              name="all_forms_valid"
              value={this.props.actions.isValid('submit')}
              validations="isTrue"
            />
            <input
              ref={this.props.actions.assignTrigger}
              type="submit"
              hidden
            />
          </Formsy>
        </div>
      </div>
    );
  }

  disableTile = ({ date: d, view }) => {
    if (view !== 'month') return false;
    const prefs = this.props.client.client_service_preferences[0];
    const day = moment(d).day();
    return this.dayOfWeekSwitch(prefs.day_of_week) !== day;
  };

  dayOfWeekSwitch = dayOfWeek =>
    ({
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6
    }[dayOfWeek] || 0);

  handleClickDay = serviceDate => this.setState({ serviceDate });

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ChefOnboarding component
  handleSubmit = (formData, data, errors) => {
    const { serviceDate } = this.state;
    // update chef
    const updatedClient = { service_start_date: serviceDate.toISOString() };
    this.props.updateClient(updatedClient);
    this.props.actions.markComplete(this.props.step);
  };

  initState(prevProps = {}) {
    const state = {};
    if (
      !prevProps.client ||
      (this.props.client.service_start_date &&
        this.props.client.service_start_date !==
          prevProps.client.service_start_date)
    ) {
      state.serviceDate =
        moment(this.props.client.service_start_date).toDate() || null;
    }

    if (state.serviceDate) this.setState(state);
  }

  reset = () => {
    this.props.updateClient({ service_start_date: null });
  };

  componentWillMount() {
    // handle resets here
    const reset = this.props.resets.includes(this.props.step);

    if (reset) this.reset();
    else this.initState();
  }

  componentDidUpdate(prevProps, nextState) {
    this.initState(prevProps);
  }
}

export default withOnboarding(ClientStartDate);



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientStartDate.js